import clsx from "clsx"

interface SidebarToggleButtonProps {
  collapsed: boolean
  onToggle: () => void
  darkMode?: boolean
}

export const SidebarToggleButton = ({ collapsed, onToggle, darkMode = false }: SidebarToggleButtonProps) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      title={collapsed ? "Expand" : "Collapse"}
      className={clsx(
        "shrink-0 hidden lg:flex items-center justify-center w-9 h-9 rounded-md",
        "transition-colors active:scale-95",
        darkMode ? "border border-[rgba(255,255,255,0.12)] hover:bg-white/5" : "border border-[rgba(233,234,236,1)] hover:bg-black/5"
      )}
    >
      <div className="relative w-4 h-4">
        <span
          className={clsx(
            "absolute left-0 top-0 h-[2px] w-full bg-current",
            "transition-all duration-200 ease-out",
            collapsed && "top-1/2 rotate-45"
          )}
        />

        <span
          className={clsx(
            "absolute left-0 top-1/2 h-[2px] w-full bg-current -translate-y-1/2",
            "transition-all duration-200 ease-out",
            collapsed ? "opacity-0" : "opacity-100"
          )}
        />

        <span
          className={clsx(
            "absolute left-0 bottom-0 h-[2px] w-full bg-current",
            "transition-all duration-200 ease-out",
            collapsed && "bottom-auto top-1/2 -rotate-45"
          )}
        />
      </div>
    </button>
  )
}
